import { render, staticRenderFns } from "./SearchPortfolioCompanyItem.vue?vue&type=template&id=4d237474&scoped=true&"
import script from "./SearchPortfolioCompanyItem.vue?vue&type=script&lang=ts&"
export * from "./SearchPortfolioCompanyItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d237474",
  null
  
)

export default component.exports